/**
 * Search Preference Type, less than 50 characters 
 */
export const SearchPreferenceType = {
    CHG_ENQ_CRITERIA: 'ChargeDataSearchCriteria',
    DOC_ENQ_CRITERIA: 'DocumentEnquiryCriteria',
    PRO_ENQ_CRITERIA: 'ProposalEnquiryCriteria',
}